import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./styles/app.css";

const KioskApp = lazy(() => import("./kiosk/KioskApp.tsx"));
const AdminApp = lazy(() => import("./admin/AdminApp.tsx"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 2, refetchOnWindowFocus: false, staleTime: 60_000 },
  },
});

const isAdmin = location.pathname === "/admin" || location.pathname.startsWith("/admin/");
if (!isAdmin) document.documentElement.classList.add("kiosk");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={null}>{isAdmin ? <AdminApp /> : <KioskApp />}</Suspense>
    </QueryClientProvider>
  </StrictMode>,
);
